import { DrawImageOnCanvas } from "./types";

export const drawImageOnCanvas: DrawImageOnCanvas = ({
  image,
  width,
  height,
}) => {
  const canvas = document.createElement("canvas");
  canvas.width = width ?? image.naturalWidth;
  canvas.height = height ?? image.naturalHeight;

  const context = canvas.getContext("2d");
  if (!context) throw new Error("Could not get canvas context");

  context.drawImage(image, 0, 0, canvas.width, canvas.height);
  return canvas;
};
